export default {
  columnLabels: {
    brand: 'Brand',
    title: 'Ad Title / Ad Code',
    lastMonthTested: 'Last Month Tested',
    sampleSize: 'Sample Size',
    rankingMetric: 'Ranking Metric',
    preview: 'Preview'
  }
}
